export default __webpack_public_path__ + "static/media/ESSK34TANZ01.c67edc7c.mp4";